import { format } from 'date-fns-tz'
import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'
import { DenseTableRowProps } from '../../../../components'
import { MembershipFeesQueryType } from '../../../../types'
import { formatBasicDateStr } from '../../../../utils'
import { MembershipFeeAccrualBases } from '../../../../utils/classes/graphql'
import { formatAccrualBaseAmount, getAccrualBaseProps } from '../../utils'
import { MembershipFeeAccrualBasesRow } from '../types'

export const getAccrualBaseOrDefaultProps = (
  accrualBasesThisYear: MembershipFeesQueryType['accrualBasesThisYear']
) => {
  let accrualBaseProps

  const firstAccrualBaseThisYear = accrualBasesThisYear?.[0]
  if (firstAccrualBaseThisYear) {
    accrualBaseProps = getAccrualBaseProps(firstAccrualBaseThisYear)
  }
  return {
    accrualBaseAmount: accrualBaseProps?.accrualBaseAmount || '0',
    accrualBaseType: accrualBaseProps?.accrualBaseType || '%'
  }
}

const formatAccrualBases = (
  accrualBases:
    | MembershipFeesQueryType['accrualBasesLastYear']
    | MembershipFeesQueryType['accrualBasesThisYear']
) => {
  const orderedAccrualBases: MembershipFeeAccrualBases[] = orderBy(
    accrualBases,
    ['maksujaksonAlkupvm', 'maksujaksonLoppupvm'],
    ['asc', 'asc']
  )

  const fixedOrdered = orderedAccrualBases.map(
    (obj: MembershipFeeAccrualBasesRow) => {
      const rowObj: DenseTableRowProps<MembershipFeeAccrualBasesRow> = {
        ...obj
      }
      const startDate = formatBasicDateStr(obj.maksujaksonAlkupvm)
      const endDate = formatBasicDateStr(obj.maksujaksonLoppupvm)
      rowObj.maksujakso = startDate + ' - ' + endDate

      rowObj.maksuperuste = formatAccrualBaseAmount(obj)

      return rowObj
    }
  )

  const grouped = groupBy(
    fixedOrdered,
    (obj) =>
      format(new Date(obj.maksujaksonLoppupvm), 'yyyy', {
        timeZone: 'Europe/Helsinki'
      }) || '-'
  )
  return grouped
}

export const groupAccrualBases = (membershipFees: MembershipFeesQueryType) => {
  const { accrualBasesLastYear, accrualBasesThisYear } = membershipFees

  const formattedAccrualBasesLastYear = formatAccrualBases(accrualBasesLastYear)
  const formattedAccrualBasesThisYear = formatAccrualBases(accrualBasesThisYear)

  const groupedAccrualBases = Object.assign(
    {},
    formattedAccrualBasesLastYear,
    formattedAccrualBasesThisYear
  )

  return groupedAccrualBases
}
